import React, { useContext, useState } from "react";
import forgotPswd from "../../../assets/forgotPswd.svg";
import MobileField from "../../../Utils/BasicComponents/MobileField";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../services/AuthProvider";

export default function ForgotPassword() {
  const { handleConfirmPassword, otpCode } = useContext(AuthContext);
  const [otp, setOtp] = useState("");
  const [createPswd, setCreatePswd] = useState("");
  const [createConfPswd, setCreateConfPswd] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const createNewPswd = async () => {
    setErrorMsg("");
    if (createPswd === createConfPswd) {
      await handleConfirmPassword(createConfPswd)
        .then(() => navigate("/login"))
        .catch((err) => console.log("err", err));
    } else {
      setErrorMsg("Passwords Does not match");
      return;
    }
  };

  return (
    <section className="w-full h-screen flex flex-col pt-14 items-center gap-[16px]">
      <div className="overflow-hidden w-fit h-fit bg-[#41D67C61] rounded-full">
        <img src={forgotPswd} alt="" />
      </div>
      <div className="w-full flex flex-col items-center">
        <MobileField
          textField={"Enter OTP"}
          isOtp={true}
          otp={otp}
          setOtp={setOtp}
        />
        <MobileField
          uniqueId="ConfigurePswd"
          textField={"New Password"}
          isOtpTrue={true}
          createPswd={createPswd}
          setCreatePswd={setCreatePswd}
        />
        <MobileField
          textField={"Confirm New Password"}
          isOtpTrue={true}
          createPswd={createConfPswd}
          setCreatePswd={setCreateConfPswd}
          errorMsg={errorMsg}
        />
      </div>
      <button
        className={`${
          createPswd && createConfPswd && otpCode
            ? "bg-[#1C75BC]"
            : "bg-[#C9C9C9]"
        } rounded-[5px] text-white text-[13px] flex justify-center px-[14px] py-[13px] font-bold`}
        onClick={createNewPswd}
        disabled={createPswd && createConfPswd && otpCode ? false : true}
      >
        CHANGE PASSWORD
      </button>
    </section>
  );
}
